// 个性化推荐管理
export default {
  routes: [
    {
      path: '/recommend-manage',
      name: 'recommendManage',
      meta: {
        desc: '个性化推荐管理',
        pageId: 'H5067'
      },
      component: () =>
        import(/* webpackChunkName: "recommendManage" */ '../views/recommendManage/index.vue')
    }
  ]
}
